import { create } from 'zustand';

export type DeductionGroupingMode = 'worker' | 'site';

interface DeductionsUIState {
  collapsedGroups: Set<string>;
  groupingMode: DeductionGroupingMode;
}

interface DeductionsUIActions {
  toggleGroup: (name: string) => void;
  setGroupingMode: (mode: DeductionGroupingMode) => void;
  reset: () => void;
}

export const useDeductionsUIStore = create<
  DeductionsUIState & DeductionsUIActions
>(set => ({
  collapsedGroups: new Set(),
  groupingMode: 'worker',
  toggleGroup: (name: string) =>
    set(state => {
      const next = new Set(state.collapsedGroups);
      if (next.has(name)) {
        next.delete(name);
      } else {
        next.add(name);
      }
      return { collapsedGroups: next };
    }),
  setGroupingMode: (mode: DeductionGroupingMode) =>
    set({ groupingMode: mode, collapsedGroups: new Set() }),
  reset: () => set({ collapsedGroups: new Set(), groupingMode: 'worker' }),
}));
